<template>
  <el-dialog center :title="$t('app.phoneVerify')" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false"
    custom-class="MyDialog" @close="closeDialog" width="500px">
    <el-row>
      <el-col :span="24">
        <el-form :model="verifyFrom" ref="verifyFrom" :rules="rules" label-width="100px">
          <el-form-item :label="$t('app.label')" prop="phone">
            <el-row>
              <el-col :span="16">
                <template v-if="BindOrderList && BindOrderList.phone">
                  <el-input type="text" :disabled="BindOrderList.phone ? true : false" v-model="verifyFrom.phone"
                    :placeholder="$t('app.pleaseEnter')" autocomplete="off"></el-input>
                </template>
                <template v-else>
                  <el-input type="text" :disabled="BindOrderList.phone ? true : false" v-model="verifyFrom.phone"
                    :placeholder="$t('app.pleaseEnter')" autocomplete="off"></el-input>
                </template>
              </el-col>
              <el-col :span="4">
                <el-button v-if="BindOrderList && BindOrderList.phone" @click="handleReplaceYourPhone">{{ $t('app.auto_324_45261ca8') }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('app.label')" prop="phoneCode">
            <el-row>
              <el-col :span="16">
                <el-input type="text" v-model="verifyFrom.phoneCode" :placeholder="$t('app.pleaseEnter')" autocomplete="off"></el-input>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" v-if="liked" @click="SendVerificationCode">{{ $t('app.auto_325_eb3c8bdb') }}</el-button>
                <span v-else>{{ count }}s后重新发送</span>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" type="primary" class="cancel-button">取 消</el-button>
      <el-button @click="dialogConfirm" type="primary" class="confirm-button">{{ $t('app.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getPhoneCode, checkPhoneCode, changeLoginPhoneBySelf, checkValidCode } from '@/api/AccountSetting';  //获取短信验证码，绑定手机号
import { toDoLogin, queryUserNavAndFunc } from "@/api/login";
import { setCookie, getCookie, delCookie } from '@/util/cookie';

export default {
  data() {
    return {
      dialogVisible: false,
      liked: true,
      isStateNum: 1,
      count: 59,
      phone: "",
      phone2: "",
      objParm: {},
      paramsLogin: {},
      isShowOpen: false,
      layerTitle: this.$t('app.auto_655_e2d64fef'),
      okText: this.$t('app.auto_656_2b7363ca'),
      verifyFrom: {
        phone: '',
        phoneCode: '',
      },
      rules: {
        phone: [
          { required: true, message: this.$t('login.pleaseEnterPhone'), trigger: 'blur' },
        ],
        phoneCode: [
          { required: true, message: this.$t('salesCenter.pleaseEnterVerifyCode'), trigger: 'blur' },
        ],
      }
    }
  },
  props: {
    showMobilePhoneVerification: {
      type: Boolean,
      default: false
    },
    bindOrderPhone: {
      type: String | Number,
      default: '',
    },
    bindUserId: {
      type: String,
      default: '',
    },
    BindOrderList: {
      type: Object,
      default: () => { }
    }
  },
  watch: {
    showMobilePhoneVerification: {
      handler(newVal, oldVal) {
        this.dialogVisible = newVal;
      },
      immediate: true
    },
    BindOrderList: {
      handler(newVal, oldVal) {
        if (newVal && newVal.phone) {
          this.verifyFrom.phone = newVal.phone;
        }
      },
    },
  },
  methods: {
    handleReplaceYourPhone() {

    },
    // 发送验证码
    SendVerificationCode() {
      if (this.bindOrderPhone == '' || this.verifyFrom.phone == '') {
        this.$message({
          message: this.$t('salesCenter.pleaseEnterPhoneFirst'),
          type: 'warning'
        });
      }
      const params = {
        mobile: this.bindOrderPhone ? this.bindOrderPhone : this.verifyFrom.phone,
      }
      getPhoneCode(params).then(res => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('app.codeSentViewOnPhone'),
            type: 'success'
          });
          let count = this.count
          const timer = setInterval(() => {
            this.count = count--;
            this.disabled = true;
            this.liked = false;
            if (this.state.count === 0) {
              clearInterval(timer);
              this.count = 59;
              this.disabled = false;
              this.liked = false;
            }
          }, 1000);
        }
        else {
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
        }
      })
    },
    handleReplaceYourPhone() {
      this.isShowOpen = true;
    },
    submit() {
      const params = {
        "phone": this.verifyFrom.phone,                //类型：String  必有字段  备注：手机号
        "phoneCode": this.verifyFrom.phoneCode,                //类型：String  必有字段  备注：验证码
        "userId": this.bindUserId.userId || ""                //类型：Number  必有字段  备注：用户ID
      }
      checkPhoneCode(params).then(ret => {
        if (ret.code === 0) {
          this.$message({
            message: ret.message || this.$t('app.auto_657_51fb12ea'),
            type: 'success'
          });
          this.$emit('confirmMobilePhoneVerification');
        }
        else {
          this.$message({
            message: ret.message || this.$t('app.auto_658_966426c5'),
            type: 'warning'
          });
        }
      })
    },
    dialogConfirm() {
      this.$refs['verifyFrom'].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit('closeMobilePhoneVerification');
    },
  }
}
</script>

<style lang="scss">
.MyDialog {
  border-radius: 20px;

  .el-dialog__header {
    background: rgb(74, 131, 232);
    border-radius: 20px 20px 0 0;

    .el-dialog__title,
    .el-dialog__close {
      color: white;
    }
  }

  .dialog-footer {
    button {
      border-radius: 20px;
    }
  }
}
</style>